const getBody = (): HTMLElement => document.getElementsByTagName('body')[0];
export default getBody;
